import { render, staticRenderFns } from "./edit-register-polite.vue?vue&type=template&id=6404c8a3&scoped=true&"
import script from "./edit-register-polite.vue?vue&type=script&lang=js&"
export * from "./edit-register-polite.vue?vue&type=script&lang=js&"
import style0 from "./edit-register-polite.vue?vue&type=style&index=0&id=6404c8a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6404c8a3",
  null
  
)

export default component.exports